import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { fetchBundleByDevicePrice } from "../services/oxygenRetailServices";
import {useSelector } from 'react-redux';
import OxygenDeviceBundleCard from '../components/OxygenDeviceBundleCard';
import useCustomAlert from '../components/Alert2';

const ProposedDeviceBundles = () => {
        // const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const navigate = useNavigate();
    const [deviceBundles, setDeviceBundles] = useState({});
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const deviceId = useSelector((state) => state?.oxygenRetail?.selectedDevice?.id);
    const precustomer =  useSelector((state) => state?.precustomer?.precustomerData.precustomer);
    const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
    const deviceType_id = localStorage.getItem("device_type_id") !== "undefined" && JSON.parse(localStorage.getItem("device_type_id"));
    const device_amount = localStorage.getItem("device_amount") !== "undefined" && JSON.parse(localStorage.getItem("device_amount"));
    console.log("device_amount", device_amount);
    const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));
    

    const handleFetchBundleByDeviceId = async() => {
        setLoading(true);
        let response;
        const payload ={ 
            amount: Number(device_amount), 
            device_type_id: Number(financierID) === 20 || Number(partnerId) === 409 ? 0 : Number(deviceId) || Number(precustomer?.bundled_device_type_id)  || Number(deviceType_id) , 
            financier_id: Number(financierID), 
            store_id: 0,
        }
        response = await fetchBundleByDevicePrice(payload);
        
        console.log("response", response);
        if(response?.status === true) {
            setLoading(false);
            setDeviceBundles(response?.data);
        }else{
            setLoading(false);
            customAlert.showToast("error", `${response?.message}` || "Failed to fetch device bundles..!");
            setErrorMessage(response?.message || "Failed to fetch device bundles..!");
        }
    }

    useEffect(() => {
        handleFetchBundleByDeviceId();
    }, [deviceId]);

    const handleSelectBundle = (bundle, device_type_id) => {
        handleSubmitBundle(bundle, device_type_id);
    }

    const handleSubmitBundle = async(bundle, device_type_id) => {
        console.log("bundle modal:", bundle, device_type_id);
        
        if(Number(financierID) === 13 || Number(partnerId) === 407){
            navigate('/fbn-prequal-form');
        }else{
            navigate('/oxygen-details-form');
        } 
    }

  return (
    <PageWrapper>
        <PageTitle title={`Proposed Device Bundle`} />

        {loading ? (
            <p className='text-center'>Fetching device bundles...</p>
        ):errorMessage ? (
            <div className="alert alert-danger" role="alert">
            {errorMessage}
        </div>
        ):(
            <>
                <div className="d-flex justify-content-end gap-3 mt-6 mb-6">
                    <button className="btn btn-primary" onClick={() => navigate("/oxygen-devices")}>Choose a New Device</button>
                </div>
                <OxygenDeviceBundleCard data={deviceBundles} onClick={handleSelectBundle} /> 
            
            </>
        )
        
        }

    </PageWrapper>
  )
}

export default ProposedDeviceBundles